module.exports = __webpack_public_path__ + "img/khandevane-gray.6856c97.png";